/** Shared mobile pro dashboard chrome — list header + sub strip, and form edit chrome. */

/** Top row: Settings title or form back + title + action. */
const MOBILE_PRO_CHROME_TOP_ROW_CLASS = "flex h-[52px] shrink-0 items-center gap-3 bg-pro-bg px-5";

const MOBILE_PRO_CHROME_TITLE_CLASS =
  "truncate font-display text-[28px] font-bold leading-none tracking-[-0.02em] text-pro-text";

const MOBILE_PRO_CHROME_TRAILING_CLASS = "ml-auto shrink-0";

/** Form edit chrome shell — single row with bottom border (replaces header + tab strip). */
const MOBILE_PRO_CHROME_FORM_HEADER_CLASS = "shrink-0 border-b border-pro-border bg-pro-bg";

/** Settings tab strip row under the top bar. */
const MOBILE_PRO_CHROME_SUB_STRIP_CLASS =
  "flex min-h-[42px] shrink-0 items-center border-b border-pro-border bg-pro-bg px-4";

export {
  MOBILE_PRO_CHROME_FORM_HEADER_CLASS,
  MOBILE_PRO_CHROME_SUB_STRIP_CLASS,
  MOBILE_PRO_CHROME_TITLE_CLASS,
  MOBILE_PRO_CHROME_TOP_ROW_CLASS,
  MOBILE_PRO_CHROME_TRAILING_CLASS,
};
